import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4f1fd7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feedback-filter" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "filter-tabs-container" }
const _hoisted_5 = { class: "count-container" }
const _hoisted_6 = { class: "count-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider pixel-up" }, null, -1))
const _hoisted_8 = { class: "filter-content" }
const _hoisted_9 = {
  key: "loading",
  class: "loading-area"
}
const _hoisted_10 = {
  key: "general",
  class: "filter-sets"
}
const _hoisted_11 = {
  key: "custom",
  class: "filter-sets"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_14 = { class: "date-picker-modal" }
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!
  const _component_LoadingFilters = _resolveComponent("LoadingFilters")!
  const _component_FilterSet = _resolveComponent("FilterSet")!
  const _component_PillButton = _resolveComponent("PillButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass([
                        'filter-tab',
                        { selected: _ctx.filterTab === 'general' },
                    ]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchTab('general')))
        }, [
          _createVNode(_component_Typography, {
            component: "span",
            class: "filter-tab-text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" General ")
            ], undefined, true),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass([
                                'filter-count',
                                { 'has-count': _ctx.activeGeneralFilterCount > 0 },
                            ])
            }, _toDisplayString(_ctx.activeGeneralFilterCount), 3)
          ])
        ], 2),
        (_ctx.canViewNameEmail)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([
                        'filter-tab',
                        { selected: _ctx.filterTab === 'custom' },
                    ]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchTab('custom')))
            }, [
              _createVNode(_component_Typography, {
                component: "span",
                class: "filter-tab-text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Custom ")
                ], undefined, true),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", {
                  class: _normalizeClass([
                                'filter-count',
                                { 'has-count': _ctx.activeCustomFilterCount > 0 },
                            ])
                }, _toDisplayString(_ctx.activeCustomFilterCount), 3)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_LoadingFilters)
          ]))
        : (_openBlock(), _createBlock(_Transition, {
            key: 1,
            name: "slide-tab-1"
          }, {
            default: _withCtx(() => [
              (_ctx.filterTab === 'general')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_FilterSet, {
                      label: "Time Filters",
                      "filter-set": _ctx.timeFilterSet,
                      class: _normalizeClass(["filter-set", [
                            'filter-set',
                            {
                                unfocus: _ctx.focusedCustomFilter !== '',
                            },
                        ]]),
                      onSelectFilter: _ctx.selectTimeFilter
                    }, null, 8, ["filter-set", "class", "onSelectFilter"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validGeneralRuleOptions, (rule) => {
                      return (_openBlock(), _createBlock(_component_FilterSet, {
                        key: rule.value,
                        label: rule.label,
                        "filter-type": rule.value,
                        "filter-set": _ctx.ruleSubOptions[rule.value],
                        "close-search": _ctx.focusedCustomFilter === '',
                        "filter-category": "general",
                        "select-mode": _ctx.getGeneralFilterSelectMode(rule.value),
                        "select-filter-loading": _ctx.filterLoading,
                        class: _normalizeClass([
                            'filter-set',
                            {
                                unfocus:
                                    _ctx.focusedCustomFilter !== '' &&
                                    _ctx.focusedCustomFilter !== rule.value,
                            },
                        ]),
                        onAddMultiSubOption: _ctx.addMultiSubOption,
                        onSelectFilter: _ctx.handleClickOption,
                        onFocus: ($event: any) => (_ctx.onFocusMultiSelectFilter(rule.value, 'general')),
                        onUnfocus: _ctx.onUnfocusMultiSelectFilter
                      }, null, 8, ["label", "filter-type", "filter-set", "close-search", "select-mode", "select-filter-loading", "class", "onAddMultiSubOption", "onSelectFilter", "onFocus", "onUnfocus"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 1
          })),
      _createVNode(_Transition, { name: "slide-tab-2" }, {
        default: _withCtx(() => [
          (_ctx.filterTab === 'custom')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validCustomRuleOptions, (rule) => {
                  return (_openBlock(), _createBlock(_component_FilterSet, {
                    key: rule.value,
                    label: rule.label,
                    "filter-type": rule.value,
                    "filter-set": _ctx.ruleSubOptions[rule.value],
                    "close-search": _ctx.focusedCustomFilter === '',
                    class: _normalizeClass([
                            'filter-set',
                            {
                                unfocus:
                                    _ctx.focusedCustomFilter !== '' &&
                                    _ctx.focusedCustomFilter !== rule.value,
                            },
                        ]),
                    "select-filter-loading": _ctx.filterLoading,
                    "filter-category": "custom",
                    "select-mode": "multi",
                    onSelectFilter: _ctx.handleClickOption,
                    onAddMultiSubOption: _ctx.addMultiSubOption,
                    onFocus: ($event: any) => (_ctx.onFocusMultiSelectFilter(rule.value)),
                    onUnfocus: _ctx.onUnfocusMultiSelectFilter
                  }, null, 8, ["label", "filter-type", "filter-set", "close-search", "class", "select-filter-loading", "onSelectFilter", "onAddMultiSubOption", "onFocus", "onUnfocus"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], undefined, true),
        _: 1
      })
    ]),
    _hoisted_12,
    _createElementVNode("div", {
      class: _normalizeClass(["filter-footer", { unfocus: _ctx.focusedCustomFilter !== '' }])
    }, [
      _createVNode(_component_Typography, {
        component: "span",
        class: "navigation-text",
        onClick: _ctx.resetFilters
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Reset Filters ")
        ], undefined, true),
        _: 1
      }, 8, ["onClick"])
    ], 2),
    _hoisted_13,
    _createVNode(_component_Modal, {
      show: _ctx.showCustomDatePicker,
      close: _ctx.closeDatePicker,
      width: '90vw',
      shake: _ctx.invalidDateRange,
      vanilla: "",
      centered: "",
      "has-close": "",
      "allow-click-out": "",
      "allow-escape": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Typography, {
            component: "span",
            class: "date-title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" STARTING DATE ")
            ], undefined, true),
            _: 1
          }),
          _createElementVNode("span", {
            class: "date-input-trigger",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDatePicker(_ctx.$refs.startDateRef)))
          }, _toDisplayString(_ctx.customStartDate.format('ddd, MMM D, YYYY')), 1),
          _createElementVNode("input", {
            ref: "startDateRef",
            type: "date",
            class: "date-input",
            value: _ctx.customStartDate.format('YYYY-MM-DD'),
            onChange: _cache[3] || (_cache[3] = (e) => _ctx.customDateStartDateChange(e))
          }, null, 40, _hoisted_15),
          _createVNode(_component_Typography, {
            component: "span",
            class: "date-title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" END DATE ")
            ], undefined, true),
            _: 1
          }),
          _createElementVNode("span", {
            class: "date-input-trigger",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openDatePicker(_ctx.$refs.endDateRef)))
          }, _toDisplayString(_ctx.customEndDate.format('ddd, MMM D, YYYY')), 1),
          _createElementVNode("input", {
            ref: "endDateRef",
            type: "date",
            class: "date-input",
            value: _ctx.customEndDate.format('YYYY-MM-DD'),
            onChange: _cache[5] || (_cache[5] = (e) => _ctx.customDateEndDateChange(e))
          }, null, 40, _hoisted_16),
          _withDirectives(_createVNode(_component_Typography, {
            component: "span",
            class: "date-title date-range-note"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" The start date must be before the end date ")
            ], undefined, true),
            _: 1
          }, 512), [
            [_vShow, _ctx.invalidDateRange]
          ]),
          _createVNode(_component_PillButton, {
            class: "apply-button",
            label: 'APPLY',
            onClick: _ctx.saveCustomDateFilter
          }, null, 8, ["onClick"])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["show", "close", "shake"])
  ]))
}